/* eslint-disable no-bitwise */

define('core/utils/hash',[], function () {
    'use strict';

    /**
     * The string hash function from Java.
     *
     * Borrowed from http://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript-jquery
     * @param  {string} str
     * @returns {number}
     */
    var calculate = function (str) {
        var hash = 0;
        var i, len, character;

        if (str.length === 0)
            return hash;
        for (i = 0, len = str.length; i < len; i++) {
            character = str.charCodeAt(i);

            hash = ((hash << 5) - hash) + character;
            // Convert to 32bit integer
            hash |= 0;
        }
        return hash;
    };
    return { calculate: calculate };
});

